/**
 * @module "view/form.object/content/base.input.content.view"
 * @description This is the base input view
 */

define('formkit/view/form.object/content/base.input.content.view',['require','exports','module','uikit/uikit','./base.content.view','../../../behavior/single.answer.value.behavior'],function(require, exports, module) {
  //prettier-ignore
  var UIKit                     = require('uikit/uikit'),
      BaseContentView           = require('./base.content.view'),
      SingleAnswerValueBehavior = require('../../../behavior/single.answer.value.behavior');

  var PreviewAnswerView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="inputView" />';
    },

    options: {
      form: null,
      readonly: false,
    },

    internalViewBindings: {
      inputView: {
        readonly: 'readonly',
      },
    },

    internalViewOptions: {
      inputView: function() {
        return {
          model: this.getAndLinkAnswerValueModel(this.model, this.form),
          bindings: {
            value: 'value',
          },
          readonly: this.getOption('readonly'),
        };
      },
    },

    behaviors: {
      SingleAnswerValueBehavior: {
        behaviorClass: SingleAnswerValueBehavior,
      },
    },

    getAndLinkAnswerValueModel: function(model, form) {
      var defaultAnswerIndex = this.getAnswerValueIndex();
      return form.getAnswerValueModel(model, defaultAnswerIndex);
    },

    /**
     * Since A Single Value Answer one has one answer per template formObject
     * (ie a checkbox), the index of such should always be 0.
     * @function
     * @return {number} The answer value index of 0.
     */
    getAnswerValueIndex: function() {
      return 0;
    },
  });

  var BaseInputContentView = BaseContentView.extend({
    internalViewOptions: BaseContentView.extendInternalViewOptions({
      previewAnswerView: function() {
        return {
          type: PreviewAnswerView,
          fluid: true,
          form: this.form,
          model: this.model,
        };
      },
    }),
  });

  BaseInputContentView.PreviewAnswerView = PreviewAnswerView;

  module.exports = BaseInputContentView;
});

